import { useContext } from 'react';
import { CountryContext } from 'src/context/CountryProvider';

export default function useCountryContext() {
  return useContext(CountryContext);
}
